import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { FiMenu, FiX } from "react-icons/fi"; // npm install react-icons
import { observer } from "mobx-react";
import { userStore } from "../modules/stores";
import { loginController } from "../modules/controllers";
import { eq } from "lodash";

const Nav = styled.nav`
  background-color: #282828;
  color: white;
  padding: 0.25rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  width: 100%;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
`;

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const LogoImage = styled.img`
  height: 40px;
  width: auto;
`;

const Logo = styled.h1`
  font-size: 1.5rem;
  font-weight: bold;
  color: white;
  margin: 0;
  font-family: "Montserrat", sans-serif;
`;

const NavLinks = styled.div`
  display: flex;
  gap: 1.5rem;

  @media (max-width: 768px) {
    flex-direction: column;
    background-color: #282828;
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    padding: 1rem 2rem;
    display: ${({ open }) => (open ? "flex" : "none")};
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  }
`;

const NavLink = styled.a`
  color: white;
  text-decoration: none;
  font-weight: 500;
  padding: 8px 16px;
  border-radius: 6px;
  transition: all 0.2s ease;
  font-family: "Montserrat", sans-serif;

  &:hover {
    background-color: #a60216;
    text-decoration: none;
  }
`;

const MenuIcon = styled.div`
  display: none;
  font-size: 1.8rem;
  cursor: pointer;
  color: white;

  @media (max-width: 768px) {
    display: block;
  }
`;

const UserInfo = styled.span`
  color: white;
  font-family: "Montserrat", sans-serif;
  font-weight: 500;

  @media (max-width: 768px) {
    display: none;
  }
`;

const Navbar = observer(() => {
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    eq(userStore.userObj, null) && userStore.fetchUser();
  }, []);

  return (
    <Nav>
      <LogoContainer>
        <LogoImage src="/FullLogo_Transparent.png" alt="Culinary IQ Logo" />
      <Logo>Culinary IQ</Logo>
    </LogoContainer>
    <UserInfo>
      Welcome,{" "}
      <b>
        {userStore.userObj?.firstName ||
          userStore.userObj?.first_name ||
          userStore.userObj?.username}
      </b>
    </UserInfo>
      <MenuIcon onClick={() => setMenuOpen(!menuOpen)}>
        {menuOpen ? <FiX /> : <FiMenu />}
      </MenuIcon>
      <NavLinks open={menuOpen}>
        <NavLink href="/app/home">Dashboard</NavLink>
        <NavLink href="/app/preferences">My Preferences</NavLink>
        <NavLink href="/app/make-a-plan">Meal Planning</NavLink>
        <NavLink href="/about">Calendar</NavLink>
        <NavLink href="/about">Grocery Cart</NavLink>
        <NavLink href="/app/settings">Settings</NavLink>
        <NavLink onClick={() => loginController.logout()}>Log Out</NavLink>
      </NavLinks>
    </Nav>
  );
});

export default Navbar;
